import {DefaultContext} from '../../utils/types';
import React from 'react';
import {State} from '../types/ReplacementItemDetails';

export const initialState: State = {
  item: undefined,
  orderItemIds: [],
  itemStatus: '',
  runDataLoading: false,
  runId: 0,
};

const defaultVal: DefaultContext<State> = {
  state: initialState,
  dispatch: null,
};

export const ReplacementItemDetailsContext = React.createContext(defaultVal);
